import { device } from '@ui-components/breakpoints';
import { regularWhite } from '@ui-components/design-tokens';
import SvgIcon from '@ui-components/SvgIcon';
import { playFontSize } from '@ui-components/typography/helpers';
import { PlayTextStyles } from '@ui-components/typography/PlayText/PlayText.styles';
import { playFocus } from '@ui-components/utils.styles';
import styled, { css } from 'styled-components';

export const StyledVariantLinkWrapper = styled.p<{ onlyAvailableInSweden?: boolean; context?: string }>`
    ${PlayTextStyles}
    color: ${regularWhite};

    ${(props) =>
        props.onlyAvailableInSweden &&
        css`
            .no-sweden && {
                display: none;
            }
        `}

    ${(props) =>
        props.context === 'top-area' &&
        css`
            margin: 10px 0;

            @media ${device.GteSmall} {
                margin-bottom: 0;
            }
        `}

    ${(props) =>
        props.context === 'top-bar' &&
        css`
            margin: 0;
            ${playFontSize(1.2)}

            @media ${device.GteSmall} {
                ${playFontSize(1.5)}
            }
        `}
`;

export const StyledVariantNoWrap = styled.span`
    white-space: nowrap;
`;

export const StyledVariantLink = styled.a`
    color: ${regularWhite};
    display: inline-block;
    text-decoration: underline;
    ${playFocus()}
`;

export const StyledVariantIcon = styled(SvgIcon)`
    margin-right: 3px;
    width: 15px;

    @media ${device.GteSmall} {
        width: 20px;
        margin-right: 3px;
        margin-left: 3px;
    }
`;
